import Box from '@mui/material/Box'
import { FC } from 'react'

import ColoredChip from '@/components/AnimatedTransactions/ColoredChip'
import FloatingChip from '@/components/AnimatedTransactions/FloatingChip'
import useDevice from '@/hooks/useDevice'

const ReceiptTableRow: FC<{
    emoji: string
    leftText: string
    rightText: string
    floatingText: string
    animationDelay: string
}> = ({ emoji, leftText, rightText, floatingText, animationDelay }) => {
    const { smScreen } = useDevice()

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: {
                    xs: 1,
                    md: 2,
                },
                ...(smScreen && {
                    '.MuiTypography-root': {
                        fontSize: '8px !important',
                        lineHeight: '12px !important',
                    },
                    fontSize: '8px !important',
                    lineHeight: '12px !important',
                    height: '12px',
                }),
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: 1,
                }}
            >
                ️{emoji}
                <ColoredChip animationDelay={'1s'} version={'light-green'}>
                    {leftText}
                </ColoredChip>
            </Box>
            <FloatingChip text={floatingText} animationDelay={animationDelay}>
                <ColoredChip animationDelay={'1.3s'} version={'light-green'}>
                    {rightText}
                </ColoredChip>
            </FloatingChip>
        </Box>
    )
}

const ReceiptTable: FC = () => {
    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <ReceiptTableRow
                animationDelay={'1.7s'}
                emoji={'✈️'}
                leftText={'Return flight, JFK - LHR'}
                rightText={'$ 423.87'}
                floatingText={'404 kgCO₂e'}
            />
            <ReceiptTableRow
                animationDelay={'1.8s'}
                emoji={'🚗️'}
                leftText={'Renal car'}
                rightText={'$ 20.99'}
                floatingText={'11 kgCO₂e'}
            />
            <ReceiptTableRow
                animationDelay={'1.9s'}
                emoji={'🏨️'}
                leftText={'Hotel stay, 3 nights'}
                rightText={'$ 309.50'}
                floatingText={'61 kgCO₂e'}
            />
        </Box>
    )
}

export default ReceiptTable
